import styled from "styled-components";
import { PillButton } from "../../../../../../CommonComponents/commonStyles";
import { Underlinelink } from "../../../Step1Setup/styles";
import { Content } from "../../styles";

export const CollapseWrap = styled.div`
  margin-bottom: 20px;
  border: solid 1px red;

  .ant-collapse {
    background: #ffffff;
    border-radius: 0px;
  }

  .ant-collapse-header {
    padding-bottom: 0 !important;
  }

  .ant-collapse-content {
    border-top: none;
    .ant-collapse-content-box {
      padding-top: 0;
    }
  }

  border: 1px solid #d4d4d4;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

export const ContentWrap = styled(Content)`
  padding-left: 30px;
  line-height: 1.5;
  padding: 7px 0 20px 30px !important;
  @media only screen and (max-width: 768px) {
    width: auto !important;
  }
`;

export const PillButtonSelect = styled(PillButton)`
  padding: 0px 0px;
  &:hover,
  &:focus {
    color: #006778;
    border-color: #d4d4d4;
  }
  height: 30px !important;
  width: 113px;
  margin: 0 0 20px 30px;
  color: #006778;
  font-family: HelveticaNeue-Medium;
  font-size: 14px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 20px 20px;
  }
`;

export const Title = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: 24px;
  line-height: 1.17;
  color: #022737;
  padding-left: 30px;
  padding-top: 19px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding-left: 20px;
    font-size: 18px;
  }
`;

export const DisplayFlexAlign = styled.div`
  display: flex;
  align-items: center;
  border: ${props => props.displayType === 'none' && props.status ? 'solid 1px red' : 'none'};

`;

export const Percentage = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  line-height: 1.17;
  color: ${props => props.textColor};
  /* margin-left: auto;
  margin-right: ${props => props.marginRight}; */
  padding: 7px 60px 20px 30px !important;
  @media only screen and (min-width: 320px) and (max-width: 475px) {
    padding-left: 20px;
  }
  @media only screen and (min-width: 475px) and (max-width: 768px) {
    padding-left: 30px;
  }
`;

export const UnderlinelinkRemove = styled(Underlinelink)`
  font-family: HelveticaNeue;
  line-height: normal;
  margin-top: 5px;
  margin-left: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    margin-top: 0px;
  }
`;

export const Check = styled.div`
  display: ${props => props.displayType};
`;

export const AccordionStatus = styled.div`
  margin-left: auto;
  margin-right: 30px;
`;

export const AccordionStatusText = styled.span`
  font-size: 16px;
  color: ${props => props.color};
  margin-left: 10px;
`;

export const AccordionBtnWrapper = styled.div`
  margin: 0 0 20px 30px;
  width: 113px;
  button {
    width: 100%
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 0 20px 20px;
  }
`;